import React from "react";
import { FaBan, FaFlag, FaLock, FaTrashCan } from "react-icons/fa6";
import "./TrustSafety.css";

const items = [
  {
    icon: <FaFlag />,
    title: "Report concerns",
    text: "Report posts, profiles, comments, or chat messages that need review.",
  },
  {
    icon: <FaBan />,
    title: "Block users",
    text: "Keep your experience focused by blocking accounts you do not want to interact with.",
  },
  {
    icon: <FaLock />,
    title: "Privacy controls",
    text: "Account settings keep profile, password, and access controls easy to find.",
  },
  {
    icon: <FaTrashCan />,
    title: "Delete account",
    text: "Clear account deletion information is available from the website and the app.",
  },
];

const TrustSafety = () => {
  return (
    <section id="safety" className="trust-section">
      <div className="trust-container">
        <div className="trust-heading">
          <h2>Built for responsible community help</h2>
          <p>
            Rescue work needs trust. Instapaw includes reporting, blocking, privacy, and account controls so people can coordinate help with more confidence.
          </p>
        </div>
        <div className="trust-grid">
          {items.map((item) => (
            <article className="trust-item" key={item.title}>
              <span>{item.icon}</span>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSafety;
